export const systemUrl = shippingo == "1" ? 'https://agents.datalogics.co.il/api/rest/' : 'https://agents.datalogics.co.il/api/rest/';
export const systemUrlApps = 'https://api.dreamax.co.il/shopify/ai-visual-merchandiser/action';
export const systemUrlBot = 'https://api.dreamax.co.il/bot/';


const fetchData = async (postData) => {
    try {
        let systemUrlLocal = systemUrl + postData.action + '?token=' + postData.token;

        if (postData.url) {
            systemUrlLocal = postData.url;
        }

        if (postData.get && postData.order_id && postData.get == 1) {
            systemUrlLocal += "&order_id=" + postData.order_id;
        }

        console.log(systemUrlLocal, postData);

        let body;
        let headers = {};

        if (postData.file) {
            // File upload: use FormData
            body = new FormData();
            body.append('file', postData.file);

            // Add other fields from postData (excluding file, url, and get/order_id which are already handled)
            for (const key in postData) {
                if (!['file', 'url', 'get', 'order_id'].includes(key)) {
                    body.append(key, postData[key]);
                }
            }
        } else {
            // Regular JSON payload
            body = JSON.stringify(postData);
            headers['Content-Type'] = 'application/json';
        }

        const response = await fetch(systemUrlLocal, {
            method: 'POST',
            body,
            headers,
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });

        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        return false;
    }
};



export default fetchData;



export const fetchDataApps = async (postData) => {
    try {

        
        let systemUrlLocal = systemUrlApps + '?token=' + postData.token;        

        // console.log(systemUrlLocal,postData)

        const formData = new FormData();
        for (const key in postData) {
            formData.append(key, postData[key]);
        }

        const response = await fetch(systemUrlLocal , {
            method: 'POST',
            body: formData,
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });
        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        let error = err;
        return false;
    }
};


export const fetchDataBot = async (postData) => {
    try {

        
        let systemUrlLocal = systemUrlBot + postData.action + '?token=' + postData.token;        

        // console.log(systemUrlLocal,postData)


        const response = await fetch(systemUrlLocal , {
            method: 'POST',
            body: JSON.stringify(postData),
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });
        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        let error = err;
        return false;
    }
};
